import axios from "axios";
import { useMutation } from "react-query";

//${process.env.REACT_APP_API_URL}/admin/tenants/1630939384?branch=dev6
const deleteTenant = async ({ identifier, branch }) => {
    const response = await axios
        .delete(
            `${process.env.REACT_APP_API_URL}/admin/tenants/${identifier}?branch=${branch}`
        )
        .catch((err) => console.log("useTenant::getTenant", err));
    return response?.data?.result;
};

export default function useDeleteTenant() {
    return useMutation("DELETE_TENANT", (tenantConfig) =>
        deleteTenant(tenantConfig)
    );
}
